import If from 'global/ErrorHandlers/If';
import styled from 'styled-components';

type PrimarySpinnerProps = {
  overlay?: boolean;
  isLoading?: boolean;
  isDarkOverlay?: boolean,
};

const PrimarySpinnerDiv = styled.div<PrimarySpinnerProps>`
  min-width: 100px;
  min-height: 100px;
  position: relative;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }

  &::before {
    content: 'Loading…';
    position: absolute;
    top: calc(50% - 15px);
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    margin-top: 0;
    margin-left: 0;
    content: '';
    border-radius: 50%;
    border-top: 4px solid #00ab6b;
    border-right: 4px solid transparent;
    animation: 0.7s linear infinite spinner;
    -webkit-animation: 0.7s linear infinite spinner;
  }

  ${({ overlay, isDarkOverlay }) =>
    overlay &&
    `
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 100;
    background: ${isDarkOverlay ? 'rgba(0,0,0,.5)': 'rgba(255,255,255,.85)'};
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  `}
`;

const PrimarySpinner = ({
  overlay,
  isLoading = true,
  ...props
}: PrimarySpinnerProps) => {
  return (
    <If condition={isLoading}>
      <PrimarySpinnerDiv
        data-cy="primary-spinner"
        overlay={overlay}
        {...props}
      />
    </If>
  );
};

export default PrimarySpinner;
